import { render, staticRenderFns } from "./NotificationUnreadIcon.vue?vue&type=template&id=d23f0c8e&scoped=true&"
import script from "./NotificationUnreadIcon.vue?vue&type=script&lang=js&"
export * from "./NotificationUnreadIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d23f0c8e",
  null
  
)

export default component.exports